import { GetRequest, PostRequest, successParam } from '@/api/base';

const apiUrl = {
    getListForPmSubscription: 'v3/web/community/subscription/getListForPm',
    computedPriceSubscription: 'v3/web/community/subscription/computedPrice'
};

// getListForPmSubscription(params: object, callback: successParam) {
//     PostRequest(apiUrl.getListForPmSubscription, params, callback);
// }
export interface GetListForPmSubscription {
    total: number;
    row: {
        ID: number;
        OrderNumber: string;
        Status: number;
        TotalPrice: string;
        StartTime: string;
        EndTime: string;
        NextPayTime: string;
        CreateTime: string;
        IntervalType: number;
        Cycles: number;
        PayPlatform: number;
        UUID: string;
        TimeZone: string;
        IsBatch: number;
    }[];
}
export function getListForPmSubscription(params: object, callback: Function) {
    GetRequest(apiUrl.getListForPmSubscription, params, callback);
}

export interface ComputedPriceSubscription {
    Price: string;
}

export function computedPriceSubscription(params: object, callback: successParam, errorCallback: Function) {
    PostRequest(apiUrl.computedPriceSubscription, params, callback, errorCallback);
}
export interface CommunitySubscriptionUsers{
    row: {
        ActivityId: null|string;
        Amcount: number;
        CommunityName: string;
        CustomizeForm: string;
        Email: null|string;
        ID: string;
        Introduction: null|string;
        Name: string;
        ProjectID: string;
        Role: string;
        RoomName: string;
        SaveFee: number;
        UnitName: string;
        TimeZone: string;
        HasSubscription: number;
        ExpireTime: string;
    }[];
    total: number;
}

export interface GetInfoSubscription {
    ID: number;
    OrderNumber: string;
    Status: number;
    TotalPrice: string;
    StartTime: string;
    EndTime: string;
    NextPayTime: string;
    CreateTime: string;
    IntervalType: number;
    Cycles: number;
    PayPlatform: number;
    UUID: string;
    TimeZone: string;
    Reason: number;
    bmUrl: string;
    Items: {
        UnitName: string;
        ID:	number;
        RoomName: string;
        RoomNumber: string;
        Name: string;
        Role: string;
        Email: string;
        ServiceType: string;
        Amount: string;
        ProjectUUID: string;
    }[];
}
export function getInfoSubscription(params: object, callback: Function) {
    GetRequest('v3/web/community/subscription/getInfo', params, callback);
}

export function cancelSubscription(params: object, callback: successParam, errorCallback: Function) {
    PostRequest('v3/web/community/subscription/cancelSubscription', params, callback, errorCallback);
}

export function delSubscription(params: object, callback: successParam) {
    PostRequest('v3/web/community/subscription/delSubscription', params, callback);
}
export interface GetListForInsSubscription {
    total: number;
    row: {
        ID: number;
        OrderNumber: string;
        Status: number;
        TotalPrice: string;
        StartTime: string;
        EndTime: string;
        NextPayTime: string;
        CreateTime: string;
        IntervalType: number;
        Cycles: number;
        PayPlatform: number;
        UUID: string;
        TimeZone: string;
        IsBatch: number;
    }[];
}
export default {};
